export type RingSlot = { label: string; count: number; failure?: boolean };

export function Ring({ slots, size = 300 }: { slots: RingSlot[]; size?: number }) {
  const r = size * 0.38;
  const cx = size / 2;
  const cy = size / 2;
  const n = Math.max(slots.length, 8);

  return (
    <svg className="topology-canvas" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={r} stroke="var(--color-border)" strokeWidth="1" fill="none" />
      <circle cx={cx} cy={cy} r={r * 0.66} stroke="var(--color-border)" strokeWidth="1" fill="none" opacity="0.5" />
      <circle cx={cx} cy={cy} r="4" fill="var(--color-text-accent)" />

      {slots.map((s, i) => {
        const a = (i * 2 * Math.PI) / n - Math.PI / 2;
        const x = cx + Math.cos(a) * r;
        const y = cy + Math.sin(a) * r;
        const stroke = s.failure ? "var(--color-text-secondary)" : "var(--color-secondary)";
        return (
          <g key={s.label}>
            <line x1={cx} y1={cy} x2={x} y2={y} stroke="var(--color-border)" strokeWidth="1" />
            <circle cx={x} cy={y} r="8" fill="var(--color-surface)" stroke={stroke} strokeWidth="1.2" strokeDasharray={s.failure ? "3 2" : undefined} />
            <text x={x} y={y - 14} fontFamily="var(--font-mono)" fontSize="10" fill="var(--color-text-secondary)" textAnchor="middle">
              {s.label}
            </text>
            <text x={x} y={y + 4} fontFamily="var(--font-mono)" fontSize="10" fill="var(--color-text)" textAnchor="middle">
              {s.count}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
